import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { HERO_SLIDES } from '../data/mock';

const HeroSlider = () => {
  const [idx, setIdx] = useState(0);
  const total = HERO_SLIDES.length;

  const next = useCallback(() => setIdx((i) => (i + 1) % total), [total]);
  const prev = () => setIdx((i) => (i - 1 + total) % total);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  const slide = HERO_SLIDES[idx];

  return (
    <section className="relative h-[78vh] min-h-[520px] md:h-[88vh] overflow-hidden bg-slate-900">
      {HERO_SLIDES.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === idx ? 'opacity-100 slide-active' : 'opacity-0'}`}
          style={{
            backgroundImage: `linear-gradient(rgba(15,21,40,0.55), rgba(15,21,40,0.55)), url(${s.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      ))}

      <div className="relative z-10 h-full max-w-[1200px] mx-auto px-6 flex flex-col items-center justify-center text-center text-white">
        <div className="flex justify-center mb-5">
          <div className="relative">
            <div className="flex items-end gap-0.5">
              <span className="w-2 h-7 bg-[#F97559] inline-block transform rotate-12" />
              <span className="w-2 h-9 bg-[#2BBECF] inline-block" />
              <span className="w-2 h-7 bg-[#F4C430] inline-block transform -rotate-12" />
            </div>
          </div>
        </div>
        <p key={`s-${idx}`} className="uppercase text-sm md:text-base tracking-[0.25em] text-white/90 mb-4 fade-up">
          {slide.subtitle}
        </p>
        <h1 key={`t-${idx}`} className="heading-display text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] max-w-5xl fade-up text-white">
          {slide.title}
        </h1>
        <div key={`c-${idx}`} className="mt-10 fade-up">
          <Link to={slide.ctaTo} className="inline-block btn-primary px-9 py-4 text-base font-semibold rounded-sm">
            {slide.cta}
          </Link>
        </div>
      </div>

      <button onClick={prev} aria-label="Previous" className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 z-10 w-12 h-12 md:w-14 md:h-14 rounded-full border border-white/40 hover:border-white/80 hover:bg-white/10 grid place-items-center text-white transition-all">
        <ChevronLeft />
      </button>
      <button onClick={next} aria-label="Next" className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 z-10 w-12 h-12 md:w-14 md:h-14 rounded-full border border-white/40 hover:border-white/80 hover:bg-white/10 grid place-items-center text-white transition-all">
        <ChevronRight />
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {HERO_SLIDES.map((_, i) => (
          <button key={i} onClick={() => setIdx(i)} aria-label={`Slide ${i+1}`}
            className={`h-1.5 rounded-full transition-all ${i === idx ? 'bg-[#F97559] w-8' : 'bg-white/50 hover:bg-white/80 w-3'}`} />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
